// Locale Actions
import * as helpers from '@/mixins/helperFunctions.js'

export const setRtl = ({ commit }, payload) => {
  commit('setRtl', payload)
}

export const changeLocales = ({ commit }, payload) => {
  commit('changeLocales', payload)
}

export const setCountriesList = ({ commit, getters }, payload) => {
  payload = payload.toLowerCase()
  // check if we have this language in locales list and grab the first match if any
  let testLocaleExists = getters.getLocales.filter(l => l.value === payload)[0]

  if (testLocaleExists.value) {
    // we try to load the relative file, if faild catch the error
    try {
      let countries = require(`@/locales/${payload}CountriesList.json`)
      commit('setCountriesList', countries)
    } catch (error) {
      countriesError()
    }
  } else {
    countriesError()
  }
}

function countriesError() {
  helpers.ktNotify({
    type: 'error',
    text: 'Localized countries list is empty of file cannot be found'
  })
}
